import DebugLogger, { createDebugLogger } from '../DebugLogger';

export const DEBUG_LOGGER_KEY = Symbol('DEBUG_LOGGER_KEY');

export const InjectDebugLogger =
  (namespace: string) =>
  <T extends object = any>(klass: T): T => {
    Reflect.defineMetadata(
      DEBUG_LOGGER_KEY,
      createDebugLogger(namespace),
      klass
    );
    return klass;
  };

export const getLogger = <T extends object = any>(klass: T): DebugLogger => {
  const logger = Reflect.getOwnMetadata(DEBUG_LOGGER_KEY, klass);

  if (!logger) {
    throw new Error('Missing @InjectDebugLogger decorator');
  }

  return logger;
};
